import {getFormat} from 'colord';
import {z} from 'zod';

import {severityIcons} from '../../components/Icon/severity';
import {arrayToRecord} from '../../functions/arrayToRecord';
import {addSlug} from '../../functions/slugify';

export const severityScaleSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    modified: z.coerce.date(),
    isArchived: z.boolean().catch(false),
    severities: z
      .object({
        id: z.string(),
        name: z.string(),
        scale: z.number().int().gte(0).lte(99),
        colour: z.string().refine((colour) => getFormat(colour) === 'hex', {
          message: 'Colour is not a hex code',
        }),
        icon: z.number().gte(0).lt(severityIcons.length).default(0),
      })
      .array()
      .nonempty()
      .transform((severities) => arrayToRecord(severities, (s) => s.id)),
  })
  .transform(addSlug);
